import { LoaderOverlay, OKELink, SANS_3, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import React, { Fragment, useState } from "react";
import { DataDownloadModal } from "../../newComps/DataDownloadModal";

const DownloadDataButton = ({ getDataToBeExported }) => {
  const [exporting, setExporting] = useState(false);
  const [showDatadownloadModal, setShowDataDownloadModal] = useState(false);
  return (
    <Fragment>
      {exporting && <LoaderOverlay loaderText="Your download is in progress. Please don't leave this page." />}
      {showDatadownloadModal && (
        <DataDownloadModal
          setExporting={setExporting}
          getDataToBeExported={getDataToBeExported}
          setShowDataDownloadModal={setShowDataDownloadModal}
        />
      )}
      <UI_BODY_SEMIBOLD_SM_DF >
        <OKELink
          onClick={() => {
            setShowDataDownloadModal(true);
          }}
          color={"black"}
        >
          {exporting ? "Downloading..." : "Download Data"}
        </OKELink>
      </UI_BODY_SEMIBOLD_SM_DF>
    </Fragment>
  );
};

export default DownloadDataButton;
